import { STATUSES } from '@/utilities/charger/chargerStatuses'
import type { Charger as ChargerCore } from '@/core/charger'
import { numbers } from '@wallbox/toolkit-ui'

export const isUpdatesAvailable = (charger: ChargerCore) => {
  const versionUpdateCompatible = numbers.toCompareVersion(
    charger.software.currentVersion,
    charger.software.latestVersion,
    numbers.OPERATOR.LT)
  const updateAvailable = versionUpdateCompatible &&
    (charger.software.updateAvailable ?? false)
  const status = charger.status.code

  return (
    updateAvailable &&
    status !== STATUSES.DISCONNECTED &&
    status !== STATUSES.CHARGING &&
    status !== STATUSES.DISCHARGING)
}

/**
 * Compares the 2 versions (v1 and v2).
 * Returns
 * 1 if v2 > v1
 * -1 if v1 > v2
 * 0 if equals
 */
function compareSemanticVersions (v1: string, v2: string): number {
  const a = v1.split('.').map(n => parseInt(n, 10))
  const b = v2.split('.').map(n => parseInt(n, 10))

  for (let i = 0; i < 3; i++) {
    if (a[i] > b[i]) return -1
    if (a[i] < b[i]) return 1
  }

  return 0
}
